export default "__VITE_ASSET__Di_y5KpW__"